// src/pages/Success.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Error = () => {
   const navigate = useNavigate();

   useEffect(() => {
    // Redirect to home page after 2 seconds
    setTimeout(() => {
       navigate('/');
    }, 2000)});
    
    return (
    <div className="flex items-center justify-center h-screen bg-green-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-red-700">Something went wrong</h1>
        <p className="mt-4 text-lg">You have cancelled the payment or we did something wrong, you'll be redirected to the app within seconds</p>
      </div>
    </div>
  );
};

export default Error;